import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="surface-card max-w-2xl px-8 py-14 text-center">
        <div className="text-xs font-semibold uppercase tracking-[0.24em] text-muted-foreground">404</div>
        <h1 className="mt-3 text-5xl font-bold text-foreground">That route does not exist in this ticketing workspace.</h1>
        <p className="mt-4 text-sm leading-7 text-muted-foreground">
          Jump back to the marketplace to keep browsing screenings.
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link to="/" className="pill-button bg-[var(--pp-charcoal)] px-6 py-4 text-white">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
